import React, {useState, useEffect} from 'react';

const Cam = (props) => {
    const camWrapStyle = {
        position: 'absolute',
        width: `${props.layout === "portrait" || props.layout === "landscape" ? props.width*props.viewHeight/100 :
            props.width*props.viewHeight/100}px`,
        rotation: props.value.cam_rotation,
        top: props.value.cam_pos_y+"%",
        left: props.value.cam_pos_x+"%",
        transform: 'translate(-50%, calc(-50% + 2px))',
        transformOrigin: "top left",
    };

    return (
        <div className="cam" style={camWrapStyle}>
            <img style={{transform: `rotate(${camWrapStyle.rotation}deg)`, width: "100%"}}
                 src={props.is_preview_marker ? props.img : props.img_hover}  className="arrowHover" alt="" id={props.value.id}/>
        </div>
    )
}

export default Cam;